import React, {Component} from 'react';
import {AppEnv} from '../env';
import PropTypes from 'prop-types';
import {Col, Row} from 'react-material-responsive-grid';
import FaltaMensaje from '../Global-W/Classes/FaltaMensaje';
import {confirmAlert} from 'react-confirm-alert';
import {alertWarning, customAlertResp, pulseLoader} from "../Global-W/NewFunctions";

export default class SelectEscuela extends Component {
    static propTypes = {
        getInscription: PropTypes.func.isRequired,
        elNivel: PropTypes.string,
        elTipo: PropTypes.string
    };

    static defaultProps = {
        elNivel: '',
        elTipo: ''
    };

    constructor(props) {
        super(props);
        this.state = {
            aux: 0,
            cct: '',
            visible: false,
            modalSchool: false,
            dataSchool: [],
            laEscuela: [],
            indicator: false,
            lasEscuelas: [],
            indxEsc: -1,
            codigo_postal: '',
            estados: [],
            municipios: [],
            elEstado: '',
            elMunicipio: ''
        };
    }

    // <=<●>=><=<●>=><=<●>=> ComponentDidMount <=<●>=><=<●>=><=<●>=>
    async componentDidMount() {
        // await this.getEstados();
        await this.getSchoolsByCountry();
        await this.setState({aux: 0});
    }

    async getSchoolsByCountry() {
        await fetch(AppEnv.apiGes + 'school/country/level/' + AppEnv.tipoApp + '/' + this.props.elNivel + '/' + this.props.id_country, {
            method: 'GET', headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        }).then(res => res.json())
            .then(async resJson => {
                if (resJson.error === undefined) {
                    await this.setState({lasEscuelas: resJson});
                }
            });
    }

    // <=<●>=><=<●>=><=<●>=> Busqueda por CP <=<●>=><=<●>=><=<●>=>
    async getEscuelasByTipoAppCP(codigo_postal) {
        let nivel = this.props.elNivel;
        await this.setState({indicator: true});
        await fetch(AppEnv.apiGes + 'escuelas/tipo/app/' + AppEnv.tipoApp + '/' + nivel + '/' + codigo_postal, {
            method: 'GET', headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        }).then(res => res.json())
            .then(resJson => {
                if (resJson.error === undefined) {
                    let array = resJson.sort(function (a, b) {
                        if (a.nombre_escuela < b.nombre_escuela) return -1;
                        if (a.nombre_escuela > b.nombre_escuela) return 1;
                        return 0;
                    });
                    let array2 = array.sort(function (a, b) {
                        if (a.estatus > b.estatus) return -1;
                        if (a.estatus < b.estatus) return 1;
                        return 0;
                    });
                    this.setState({lasEscuelas: array2});
                }
            });
        await this.setState({indicator: false});
    }

    async codigoPost(text) {
        await this.setState({codigo_postal: text, laEscuela: [], indxEsc: -1});
        if (this.state.codigo_postal.length === 5) {
            await this.getEscuelasByTipoAppCP(this.state.codigo_postal);
        }
        await this.setState({aux: 0});
    }

    // <=<●>=><=<●>=><=<●>=> Busqueda por Ciudad <=<●>=><=<●>=><=<●>=>
    // +-+-+-+-+-+-+-+-+-+-+-+-+-+- Get estados +-+-+-+-+-+-+-+-+-+-+-+-+-+-
    async getEstados() {
        await fetch(AppEnv.apiGes + 'get/estados/todos', {
            method: 'GET', headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(res => res.json())
            .then(responseJson => {
                if (responseJson.error === undefined) {
                    this.setState({estados: responseJson});
                }
            });
    }

    async onChangeEstado(option) {
        await this.setState({elEstado: option, laEscuela: [], indxEsc: -1});
        await this.getMunicipios(option);
        if (this.state.elMunicipio !== '' && this.props.elNivel !== '') {
            await this.getEscuelasByTipoAppCiudad(option, this.state.elMunicipio);
        }
    }

    // +-+-+-+-+-+-+-+-+-+-+-+-+-+- Get municipios +-+-+-+-+-+-+-+-+-+-+-+-+-+-
    async getMunicipios(estado) {
        await fetch(AppEnv.apiGes + 'get/municipios/' + estado.toUpperCase(), {
            method: 'GET', headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(res => res.json())
            .then(responseJson => {
                if (responseJson.error !== undefined) {

                } else {
                    this.setState({municipios: responseJson});
                }
            });
    }

    async onChangeMuniocipio(option) {
        await this.setState({elMunicipio: option, laEscuela: [], indxEsc: -1});
        if (this.state.elEstado !== '' && this.props.elNivel !== '') {
            await this.getEscuelasByTipoAppCiudad(this.state.elEstado, option);
        }
    }

    async getEscuelasByTipoAppCiudad(estado, municipio) {
        let nivel = this.props.elNivel;
        await this.setState({indicator: true});
        await fetch(AppEnv.apiGes + 'escuelas/cliente/ciudad/' + AppEnv.tipoApp + '/' + nivel + '/' + estado + '/' + municipio, {
            method: 'GET', headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        }).then(res => res.json())
            .then(resJson => {
                if (resJson.error === undefined) {
                    let array = resJson.sort(function (a, b) {
                        if (a.nombre_escuela < b.nombre_escuela) return -1;
                        if (a.nombre_escuela > b.nombre_escuela) return 1;
                        return 0;
                    });
                    let array2 = array.sort(function (a, b) {
                        if (a.estatus > b.estatus) return -1;
                        if (a.estatus < b.estatus) return 1;
                        return 0;
                    });
                    this.setState({lasEscuelas: array2});
                }
            });
        await this.setState({indicator: false});
    }

    async faltante() {
        alertWarning('Selecione un estado para continuar');
    }

    // <=<●>=><=<●>=><=<●>=> Busqueda por CCT <=<●>=><=<●>=><=<●>=>
    async getEscuelasByTipoAppCCT(cct) {
        let nivel = this.props.elNivel;
        await this.setState({indicator: true});
        await fetch(AppEnv.apiGes + 'get/clientes/cct/' + AppEnv.tipoApp + '/' + nivel + '/' + cct, {
            method: 'GET', headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        }).then(res => res.json())
            .then(resJson => {
                if (resJson.error === undefined) {
                    let array = resJson.sort(function (a, b) {
                        if (a.nombre_escuela < b.nombre_escuela) return -1;
                        if (a.nombre_escuela > b.nombre_escuela) return 1;
                        return 0;
                    });
                    let array2 = array.sort(function (a, b) {
                        if (a.estatus > b.estatus) return -1;
                        if (a.estatus < b.estatus) return 1;
                        return 0;
                    });
                    this.setState({lasEscuelas: array2});
                }
            });
        await this.setState({indicator: false});
    }

    async cctSchool(text) {
        await this.setState({cct: text, laEscuela: [], indexEsc: -1});
        if (this.state.cct.length === 10) {
            await this.getEscuelasByTipoAppCCT(this.state.cct);
        }
        await this.setState({aux: 0});
    }

    // <=<●>=><=<●>=><=<●>=> CardEscuelas <=<●>=><=<●>=><=<●>=>
    async escuelaSelect(it, i) {
        if (it.estatus === 'si') {
            await this.setState({laEscuela: it, indxEsc: i});
        } else {
            confirmAlert({
                customUI: ({onClose}) => {
                    return customAlertResp('Página web personalizada',
                        'Para este colegio creamos su propia página personalizada. Para verla haga click en "Ir a la página"', 2,
                        'Ir a la página', 'En otro momento', null,
                        () => [window.location.assign(it.data_cliente.url), onClose()], () => [onClose()]);
                }
            });
        }
    }

    rndEscuelasControl() {
        let escBtns = [];
        this.state.lasEscuelas.forEach((it, i) => {
            let ixEsc = this.state.indxEsc;
            if (it.estatus !== 'no') {
                let picture = 'https://galeriasce.s3-us-west-2.amazonaws.com/img-repos/' + it.data_cliente.cct + '/logo_preinscripcion.png';
                escBtns.push(
                    <Row key={i + 'eschools'} className="uk-width-1-1 normal_text" style={{
                        margin: 0,
                        padding: 0,
                        borderRadius: 6,
                        border: '1px solid',
                        height: '10vh',
                        borderColor: AppEnv.grayColorOne,
                        marginBottom: 6,
                        backgroundColor: it.estatus === 'si' && ixEsc === i ? AppEnv.grayColorOne : '#fff',
                        overflow: 'hidden'
                    }} onClick={() => this.escuelaSelect(it, i)}>
                        <Row className="uk-width-1-5" style={{
                            margin: 0,
                            padding: 0,
                            alignItems: 'center',
                            backgroundColor: AppEnv.fourthColor,
                            height: '100%'
                        }}>
                            <Row className="uk-width-1-1 centerAll" style={{height: '100%'}}>
                                <img alt="" style={{
                                    height: '80%',
                                    objectFit: 'contain'
                                }}
                                     src={picture}/>
                            </Row>
                        </Row>
                        <Row className="uk-width-4-5 centerAll"
                             style={{margin: 0, padding: 10, paddingLeft: 10, alignItems: 'center', height: '100%'}}>
                            <div className="uk-width-1-1">
                                <div className="section_title_two uk-width-1-1" style={{
                                    textAlign: 'left',
                                    color: '#000'
                                }}>
                                    {it.nombre_escuela.toUpperCase()} ({it.turno})
                                </div>
                                <div className="uk-width-1-1" style={{
                                    color: '#000',
                                    textAlign: 'left'
                                }}>
                                    Nivel: <label className="section_title_two"
                                                  style={{color: '#000'}}>{this.props.elNivel} </label>
                                </div>
                                <Row className="uk-width-1-1"
                                     style={{marginTop: 3, justifyContent: 'flex-end'}}>
                                    <div className="uk-width-1-2" style={{
                                        padding: 6,
                                        margin: 0,
                                        backgroundColor: '#fff',
                                        borderRadius: 6
                                    }}>
                                        <div style={{color: it.estatus === 'si' ? AppEnv.greenColor : 'blue'}}>
                                            {it.estatus === 'si' ? 'Disponible' : null}
                                            {it.estatus === 'otro' ? 'App personalizada' : null}
                                        </div>
                                    </div>
                                </Row>
                            </div>
                        </Row>
                    </Row>
                );
            }
        });
        return escBtns;
    }

    async getInscription(laEscuela) {
        await this.props.getInscription(laEscuela);
        await this.setState({dataSchool: laEscuela.data_cliente, globals: laEscuela.globals});
    }

    render() {
        return (
            <div className="uk-width-1-1 normal_text centerAll">
                {/*{this.props.elTipo === 'Código postal' ? this.rndCapturaCp() : null}*/}
                {/*{this.props.elTipo === 'Ciudad' ? this.rndCaputraCiudad() : null}*/}
                {/*{this.props.elTipo === 'CCT' ? this.rndCapturaCCT() : null}*/}
                {this.state.indicator === true ?
                    <Row className={'uk-width-1-1@s centerAll'}>
                        {pulseLoader()}
                    </Row> : this.state.lasEscuelas.length !== 0 ?
                        <Col className='uk-width-1-1 centerAll'>
                            <Row style={{marginTop: 10}} className='uk-width-1-1 main_title'>
                                Seleccione el colegio
                            </Row>
                            <Row style={{marginTop: 10, height: '42vh', marginBottom: 10}}
                                 className="uk-width-1-1 scroll centerH">
                                <div className="uk-width-1-1 centerAll">
                                    {this.rndEscuelasControl()}
                                </div>
                            </Row>
                        </Col> : null}
                {this.props.elTipo === 'Código postal' && this.state.lasEscuelas.length === 0 && this.state.indicator === false ?
                    <FaltaMensaje mensaje={
                        this.state.codigo_postal.length === 5 && this.state.lasEscuelas.length === 0
                            ? 'No hay escuelas en\néste código postal\nasegúrese de que este\ncorrectamente capturado' : 'Caputure un código postal válido'
                    }/> : null}
                {this.state.lasEscuelas.length === 0 && this.state.indicator === false ?
                    <FaltaMensaje mensaje={'No hay escuelas en ésta selección'}/> : null}
                {this.props.elTipo === 'CCT' && this.state.lasEscuelas.length === 0 && this.state.indicator === false ?
                    <FaltaMensaje mensaje={this.state.cct.length === 10
                        ? 'No se encontro el colegio con este CCT\nasegúrese de que este\ncorrectamente capturado'
                        : 'Capture un CCT válido'}/> : null}
                {this.state.indxEsc !== -1 ? <Row className="uk-width-1-1 centerAll" style={{
                    margin: 0,
                    padding: 10,
                    backgroundColor: AppEnv.secondColor,
                    borderRadius: 6,
                    marginTop: 20,
                    marginBottom: 10
                }} onClick={() => this.getInscription(this.state.laEscuela)}>
                    <label className="txtnegritas" style={{color: AppEnv.fourthColor}}>
                        Continuar
                    </label>
                </Row> : null}
            </div>
        );
    }
}
